import { CommonButton } from "@components/CommonButton";
import { Trans } from "react-i18next";
import { useLinkAccount } from "../hooks/useLinkAccount";
import { twMerge } from "tailwind-merge";

interface ReconnectButtonProps {
  className?: string;
}

export const ReconnectButton = ({ className }: ReconnectButtonProps) => {
  const go2OpenAuth = useLinkAccount();
  return (
    <CommonButton
      type="default"
      size="small"
      className={twMerge(
        "h-[28px]! shrink-0 rounded-[6px]! border border-kds-border-solid! bg-kds-bg-element! px-[10px]! py-[6px]! text-[14px]! font-medium! leading-[16px]! text-kds-fg! shadow-[0_1px_3px_0_var(--kds-shadow)]",
        className,
      )}
      loading={go2OpenAuth.isPending()}
      onClick={go2OpenAuth}
    >
      <Trans>Reconnect</Trans>
    </CommonButton>
  );
};
